import FanDeleteCardModalComponent from "./FanDeleteCardModalComponent";

export default FanDeleteCardModalComponent;
